import type {
  SecurityClearanceApiResponseItem,
  SecurityClearanceListItem,
} from "@services/security-clearance/types";

export const mapSecurityClearances = (data: SecurityClearanceListItem[]) =>
  data.map(
    (item: SecurityClearanceApiResponseItem): SecurityClearanceListItem => ({
      id: item.id,
      serialNo: String(item.serialNumber ?? ""),
      passportNo: item.applicant?.passportNumber ?? null,
      nationality: item.applicant?.presentNationality ?? "",
      name: item.applicant?.fullNameEnglish ?? "",
      arabicName: item.applicant?.fullNameArabic ?? "",
      emiratesIdNumber: item.applicant?.emiratesIdNumber ?? null,
      companyCode: item.sponsorOfEntry ?? "",
      fottEntry: item.fottEntry ?? false,
      dateSubmitted: item.applicationDate ?? "",
      validityPeriod: item.validityPeriod ?? "",
      status: item.status,
      taskId: item.task?.taskId ?? null,
      taskStatus: item.task?.status ?? null,
      claimOwnerName: item.task?.claimOwnerName ?? null,
    }),
  );
